﻿export abstract class QueryParameters {

    static get SearchTerm() { return "searchTerm" }

    public static getSearchTerm(): string {
        return this.getParameterValue(QueryParameters.SearchTerm);
    }

    public static setSearchTerm(value: string) {
        this.setParameterValue(QueryParameters.SearchTerm, value);
    }

    public static getParameterValue(parameterName: string): string {
        const queryParams = new URLSearchParams(window.location.search);
        const result = queryParams.get(parameterName);

        return result ? decodeURIComponent(result) : "";
    }

    public static setParameterValue(parameterName: string, value: string) {
        if (value.length === 0)
            return;

        value = encodeURIComponent(value);

        const searchParams = new URLSearchParams(window.location.search);
        searchParams.set(parameterName, value);

        const newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
        window.history.pushState(null, '', newRelativePathQuery);
    }
}